import React, { Component } from 'react';
import Form from 'react-validation/build/form';
import Input from 'react-validation/build/input';
import Select from 'react-validation/build/select';
import Textarea from 'react-validation/build/textarea';
import Button from 'react-validation/build/button';
import './../../custom.css';
import './../../pages/invoice.css';
import states from './statesArr';
import country_arr from './countrysArr';
import cityStateDict from './cityArr';
import validator from 'validator';

  const required = (value) => {
    if (!value.toString().trim().length) {
      // We can return string or jsx as the 'error' prop for the validated Component
      return <div className="alert alert-danger fieldErrorMessage" role="alert"><i className="fa fa-exclamation-circle"></i> This field is required.</div>;
    }
  };
  const FullName = (value) => {
      var patt = new RegExp("[a-zA-Z]+ [a-zA-Z]+");
      if(!patt.test(value) || value[0] === " " || value[value.length - 1] === " "){
          return <div className="alert alert-danger fieldErrorMessage" role="alert"><i className="fa fa-exclamation-circle"></i> Please enter your full name.</div>;
      }
  };
  const email = (value) => {
    if (!validator.isEmail(value)) {
        return <div className="alert alert-danger fieldErrorMessage" role="alert"><i className="fa fa-exclamation-circle"></i> Please enter valid email.</div>;
    }
  };
  const PhoneNumber = (value) => {
    if(!validator.isNumeric(value) || value.toString().trim().length > 14 || value.toString().trim().length < 8 ){
        return <div className="alert alert-danger fieldErrorMessage" role="alert"><i className="fa fa-exclamation-circle"></i> Please enter valid Phone number.</div>;
    }
  };
  const quantityRule = (value) => {
    //isDecimal(str [, options])
    //isInt(str [, options])
    // 
    if (!validator.isInt(value.toString(), {min: 1, max: 100}) ) {
        return <div className="alert alert-danger fieldErrorMessage" role="alert"><i className="fa fa-exclamation-circle"></i> Please enter valid integer between 1 and 100</div>;
    }
};
class delivery extends Component {
      constructor(props) {
        super(props);
        this.state = {
            name: '',
            email: '',
            phone: '',
            country: '',
            countryName: '',
            state: '',
            stateName: '',
            city: '',
            cityName: '',
            building: '',
            street: '',
            floor: '',
            apartment: '',
            postal_code: '',
            notes: '',
            firstPhase:true
        };
        this.getFirstName = this.getFirstName.bind(this);
        this.getLastName = this.getLastName.bind(this);
        this.renderStates = this.renderStates.bind(this);
        this.renderCity = this.renderCity.bind(this);
        this.handleNameChange = this.handleNameChange.bind(this);
        this.handleEmailChange = this.handleEmailChange.bind(this);
        this.handlePhoneChange = this.handlePhoneChange.bind(this);
        this.handleCountryChange = this.handleCountryChange.bind(this);
        this.handleStateChange = this.handleStateChange.bind(this);
        this.handleStateChange2 = this.handleStateChange2.bind(this);
        this.handelCityChange = this.handelCityChange.bind(this);
        this.handleCityChange2 = this.handleCityChange2.bind(this);
        this.handleBuildingChange = this.handleBuildingChange.bind(this);
        this.handleStreetChange = this.handleStreetChange.bind(this);
        this.handleFloorChange = this.handleFloorChange.bind(this);
        this.handleApartmentChange = this.handleApartmentChange.bind(this);
        this.handlePostalCodeChange = this.handlePostalCodeChange.bind(this);
        this.handleNotesChange = this.handleNotesChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.setProductSubData = this.setProductSubData.bind(this);
        this.firstPhaseHandel = this.firstPhaseHandel.bind(this);
        this.setProductSubData();
      }
  
    setProductSubData(){
        if(this.props.sourcePage === 'product'){
            if(this.props.currentDeliveryData.name){
                this.state.name = this.props.currentDeliveryData.name;
                this.state.email = this.props.currentDeliveryData.email;
                this.state.phone = this.props.currentDeliveryData.phone;
            }
        }
    }
    getFirstName(fullName) {
        var namesArr = fullName.split(" ");
        return namesArr[0]
    }
    getLastName(fullName) {
        var namesArr = fullName.split(" ");
        return namesArr[namesArr.length - 1];
    }
    handleNameChange(e) {
        this.setState({name: e.target.value}); 
    }
    handleEmailChange(e) {
        this.setState({email: e.target.value}); 
    }
    handlePhoneChange(e) {
        this.setState({phone: e.target.value}); 
    }
  handleCountryChange(e) {
    let countryName = country_arr[e.target.value - 1]
    this.setState({country: e.target.value, countryName: countryName,state: '', stateName: '', city: '', cityName: ''});
  }
  handleStateChange(e) {
    if(e.target.value !== '-1'){
        let currentState = states[this.state.country].split("|")[e.target.value - 1];
        this.setState({state: e.target.value,stateName: currentState, city: '', cityName: ''});
    }else{
        this.setState({state: e.target.value, stateName: '', city: '', cityName: ''});
    }
  }
  handleStateChange2(e) {
      this.setState({stateName: e.target.value});
  }
  handelCityChange(e) {
    if(e.target.value !== '-1'){
        this.setState({city: 1, cityName: e.target.value});
    }else{
        this.setState({city: e.target.value});
    }
    
  }
  handleCityChange2(e) {
    this.setState({cityName: e.target.value});
  }
  firstPhaseHandel(){
    this.setState({firstPhase: !this.state.firstPhase});
  }
  renderStates(){
      if(this.state.country === ''){
        return (
            <select className="premSelect" id="state" name="state">
                <option value=''>Select Country First</option>
            </select>
        )
      }else{
        let currentStatesArr = states[this.state.country].split("|");
        return (
            <select className="premSelect" id="state" name="state" 
                value={this.state.state} 
                onChange={this.handleStateChange}
                validations={[required]} 
            >
                <option value='' disabled>Select State From {country_arr[this.state.country - 1]}</option>
                {currentStatesArr.map((ele, index)=>{
                    return <option key={index} value={index + 1} >{ele}</option>
                })}
                <option value={-1}>--Other--</option>
            </select>
        )
      }
  }
  renderCity() {
    let cityTextInput;
    if(this.state.state === ''){
        cityTextInput = <Input type="text"  name="c_pan_U" placeholder="Select State First" required disabled={true} value={this.state.cityName} onChange={this.handleCityChange2} validations={[required]} />;
    }else{
        cityTextInput = <Input type="text"  name="c_pan_U" placeholder="City" required disabled={false} value={this.state.cityName} onChange={this.handleCityChange2} validations={[required]} />;
    }
      if(country_arr[this.state.country - 1] === 'Egypt'){
        if(this.state.state === ''){
            return (
                <Select className="premSelect" id="city" name="city"
                    validations={[required]} 
                >
                    <option value="" disabled>Select State First</option>
                </Select>
            )
        }else if(this.state.state === '-1'){
            return cityTextInput
        }else{
            //get city array for current state
            let currentState = states[this.state.country].split("|")[this.state.state - 1];
            let cityArrForCurrentState = [];
            for(let i=0; i < Object.keys(cityStateDict).length; i++){
                if(cityStateDict[Object.keys(cityStateDict)[i]] === currentState){
                    cityArrForCurrentState.push(Object.keys(cityStateDict)[i]);
                }
            }
            if(this.state.city === '-1'){
                return (
                    <div>
                        <Select className="premSelect" id="city" name="city" 
                            value={this.state.city} 
                            onChange={this.handelCityChange}
                            validations={[required]}
                            >
                            <option value=''>Select City</option>
                            {cityArrForCurrentState.map((ele, index)=>{
                                return <option key={index} value={ele}>{ele}</option>
                            })}
                            <option value={-1}>--Other--</option>
                        </Select>
                        {cityTextInput}
                    </div>
                )
            }else{
                return (
                    <Select className="premSelect" id="city" name="city" 
                        value={this.state.cityName} 
                        onChange={this.handelCityChange}
                        validations={[required]} 
                    >
                        <option value=''>Select City</option>
                        {cityArrForCurrentState.map((ele, index)=>{
                            return <option key={ele} value={ele}>{ele}</option>
                        })}
                        <option value={-1}>--Other--</option>
                    </Select>
                )
            }
        }
      }else{
        return cityTextInput
      }
  }
  handleBuildingChange(e){
    this.setState({building: e.target.value});
  }
  handleStreetChange(e){
    this.setState({street: e.target.value});
  }
  handleFloorChange(e){
    this.setState({floor: e.target.value});
  }
  handleApartmentChange(e){
    this.setState({apartment: e.target.value});
  }
  handlePostalCodeChange(e){
    this.setState({postal_code: e.target.value});
  }
  handleNotesChange(e){
    this.setState({notes: e.target.value});
  }
  handleSubmit(event) {
    event.preventDefault();
    let client_data;
    if(this.props.sourcePage === 'invoice'){
        client_data = {
            'name': this.props.userData.order_full_name,
            'email': this.props.userData.order_email,
            'phone': this.props.userData.order_phone,
            'country': this.state.countryName,
            'state': this.state.stateName,
            'city': this.state.cityName,
            'building': this.state.building,
            'street': this.state.street,
            'floor': this.state.floor,
            'apartment': this.state.apartment,
            'postal_code': this.state.postal_code,
            'notes': this.state.notes
        }
    }else if(this.props.sourcePage === 'product'){
        client_data = {
            'name': this.state.name,
            'email': this.state.email,
            'phone': this.state.phone,
            'country': this.state.countryName,
            'state': this.state.stateName,
            'city': this.state.cityName,
            'building': this.state.building,
            'street': this.state.street,
            'floor': this.state.floor,
            'apartment': this.state.apartment,
            'postal_code': this.state.postal_code,
            'notes': this.state.notes
        }
    }
    this.props.setDeliveryData(client_data);
    this.props.setSubDataComplelte();

  }

  render() {
    return (
        <div className="premPanel deleveryForm">
            <div className="panel-body" id="cash_content">
                <Form onSubmit={this.handleSubmit}>
                {
                    this.state.firstPhase?
                    
                <div className="firstPhase">
                    {this.props.sourcePage === 'invoice'?
                    // <div>
                    //     <div className="input-group">
                    //         <input type="text"  id="first_name" name="c_pan_U" required 
                    //             value={this.getFirstName(this.props.userData.order_full_name)} 
                    //             disabled
                    //         />
                    //     </div>
                    //     <div className="inputDiv">
                    //         <input type="text"   id="last_name" name="c_pan_U" placeholder="Name" required 
                    //             value={this.getLastName(this.props.userData.order_full_name)} 
                    //             disabled
                    //         />
                    //     </div>
                    //     <div className="inputDiv">
                    //         <input type="email"  id="email" name="c_pan_U" placeholder="email@gmail.com" required 
                    //             value={this.props.userData.order_email} 
                    //             disabled
                    //         />
                    //     </div>
                    //     <div className="inputDiv">
                    //         <div className="input-group">
                    //             <input type="text"  id="phone_number" name="c_pan_U" placeholder="phone number" required 
                    //                 value={this.props.userData.order_phone} 
                    //                 disabled
                    //             />
                    //         </div>
                    //     </div>
                    // </div>
                    <div >
                        <div className="inputDiv">
                                <Input type="text"  name="c_pan_U" placeholder="Full Name" 
                                     value={this.getFirstName(this.props.userData.order_full_name)} 
                                     disabled
                                />
                        </div>
                        <div className="inputDiv">
                                <Input type="text"  name="c_pan_U" placeholder="Full Name" 
                                     value={this.getLastName(this.props.userData.order_full_name)} 
                                     disabled
                                />
                        </div>
                        <div className="inputDiv">
                            <Input type="text"  name="c_pan_U" placeholder="Email Address "
                                value={this.props.userData.order_email} 
                                disabled
                            />
                        </div>
                        <div className="inputDiv">
                                <Input type="number" pattern="[0-9]*"  name="c_pan_U" placeholder="Phone Number" 
                                    value={this.props.userData.order_phone} 
                                    disabled
                                />
                        </div>
                        <Button className="btn btn-primary active premBtn" onClick={this.firstPhaseHandel}>Next</Button>
                    </div>
                    :
                    <div >
                        <div className="inputDiv">
                            <div className="quantityDiv">
                            {
                                !this.props.quantityFormComplete?
                                    <div className="quantity">
                                        <h4 className="greyFont">Quantity:</h4>
                                        <Input type="number"  placeholder="Enter the number of items"
                                            value={this.props.quantity}
                                            onChange={this.props.handelQuantityChange}
                                            validations={[required, quantityRule]}
                                            disabled
                                        />
                                        {
                                            !this.props.quantityFormComplete?
                                            <div className="quntaityControl">
                                                <button onClick = {this.props.incrementQuantity} className="plus">+</button> 
                                                <button onClick = {this.props.decrementQuantity} className="minus">-</button> 
                                            </div>
                                            :
                                            null
                                        }
                                        
                                    </div>
                                :
                                <div></div>
                            }
                                
                                <div className="totalQuantity">
                                    <h4 className="greyFont">Total Amount</h4>
                                    <h3><label>{(this.props.total ) + ' ' + this.props.userData.currency}</label></h3>
                                </div>
                            </div>
                        </div>
                        <div className="inputDiv">
                                <Input type="text"  name="c_pan_U" placeholder="Full Name" 
                                    value={this.state.name}
                                    onChange={this.handleNameChange}
                                    validations={[required, FullName]}
                                />
                        </div>
                        <div className="inputDiv">
                            <Input type="text"  name="c_pan_U" placeholder="Email Address "
                                value={this.state.email}
                                onChange={this.handleEmailChange}
                                validations={[required, email]}
                            />
                        </div>
                        <div className="inputDiv">
                                <Input type="number" pattern="[0-9]*"  name="c_pan_U" placeholder="Phone Number" 
                                    value={this.state.phone} 
                                    onChange={this.handlePhoneChange}
                                    validations={[required, PhoneNumber]}
                                />
                        </div>
                        <Button className="btn btn-primary active premBtn" onClick={this.firstPhaseHandel}>Next</Button>
                    </div>
                    }
                </div>
                    
                    :
                    <div className="secondPhase">
                        <h3>Delivery Info</h3>
                        <div className="inputDiv">
                            <Select className="premSelect" id="country" name ="country" 
                                validations={[required]} 
                                value={this.state.country}
                                onChange={this.handleCountryChange}
                            >
                                <option value='' disabled>Select Country</option>
                                {
                                    country_arr.map((ele, index)=>{
                                        return <option key={index} value={index + 1}>{ele}</option>
                                    })
                                }
                            </Select>
                        </div>
                        <div className="inputDiv">
                                {this.renderStates()}
                                {this.state.state === '-1'?
                                    <Input type="text"  name="c_pan_U" placeholder="Other state" 
                                        validations={[required]} 
                                        value={this.state.stateName}
                                        onChange={this.handleStateChange2}
                                    />
                                    :
                                    null
                                }
                        </div>
                        <div className="inputDiv">
                            <div className="form-group">
                                {this.renderCity()}
                            </div>
                        </div>
                        <div className="inputDiv">
                            <Input type="text"  name="c_pan_U" placeholder="Street" required 
                                value={this.state.street}
                                onChange={this.handleStreetChange}
                                validations={[required]}
                            />
                        </div>
                        <div className="address">
                            <div className="inputDiv">
                                <Input type="text" className="" name="c_pan_U" placeholder="building" required 
                                    value={this.state.building}
                                    onChange={this.handleBuildingChange}
                                    validations={[required]}
                                />
                            </div>
                            <div className="inputDiv">
                                <Input type="text" name="c_pan_U" placeholder="Floor" required 
                                    value={this.state.floor}
                                    onChange={this.handleFloorChange}
                                    validations={[required]}
                                />
                            </div>
                            <div className="inputDiv">
                                <Input type="text" name="c_pan_U" placeholder="Apartment" required 
                                    value={this.state.apartment}
                                    onChange={this.handleApartmentChange}
                                    validations={[required]}
                                />
                            </div>
                        </div>
                        <div className="inputDiv">
                            <Input type="text" name="c_pan_U" placeholder="POSTAL CODE" required 
                                value={this.state.postal_code}
                                onChange={this.handlePostalCodeChange}
                                validations={[required]}
                            />
                        </div>
                        <div className="inputDiv">
                            <Textarea type="text" name="c_pan_U" placeholder="Additional Note" 
                                value={this.state.notes}
                                onChange={this.handleNotesChange}
                            ></Textarea>
                        </div>
                        <Button className="btn btn-primary active premBtn">Next</Button>
                    </div>
                }


                    {/* <div className='text-center'>
                        <Button className="btn btn-primary active">PROCEED</Button>
                    </div> */}
                </Form>
            </div>
        </div>
    );
  }
}

export default delivery;
